import { BrandType } from 'models/brand.model';
import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import './styles.scss';
import EditBrandModal from './edit-brand-modal';
import { handleApiError } from 'utils/functions';
import { SideModal } from '@cokitchen/cokitchen-components';

const ManageBrandModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [loading, setLoading] = useState(false);
  const [brand, setBrand] = useState<null | BrandType>(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const getBrandDetails = async () => {
    setLoading(true);
    try {
      const res = await apiService.get('company/get-brand');
      setBrand(res.data.data);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateCompanyBrand = (name: string, images: string[]) => {
    if (brand) setBrand({ ...brand, name, images });
  };

  useEffect(() => {
    getBrandDetails();
  }, []);
  return (
    <SideModal
      closeBtnVariant='side'
      bodyClassName='w-[98vw] sm:w-[450px]'
      showTopNavbar
      title={
        <div className='flex justify-between items-center'>
          <div>
            <p className='text-[20px] text-[#2E3031] font-medium'>Brand details</p>
            <p className='text-[#6F7376]'>Manage your brand details</p>
          </div>
          <button
            onClick={() => setShowEditModal(true)}
            className='text-[#E60A2B] font-medium mr-6'>
            Edit
          </button>
        </div>
      }
      isOpen={isOpen}
      onRequestClose={onClose}>
      <div className='my-[40px]'>
        {loading ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>Loading.....</p>
          </div>
        ) : !brand ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>No brand details</p>
          </div>
        ) : (
          <div className='rounded-[10px] flex flex-col'>
            <div className='h-[145px] w-auto'>
              <img
                src={brand.images[0]}
                alt=''
                className='rounded-t-[10px] h-full w-full object-cover'
              />
            </div>
            <p className='brand__details__name p-4 rounded-b-[10px] bg-white font-medium text-sm text-[#1A1A1A]'>
              {brand.name}
            </p>
          </div>
        )}
      </div>
      {showEditModal && brand && (
        <EditBrandModal
          show={showEditModal}
          onClose={() => setShowEditModal(false)}
          brand={brand}
          updateCompanyBrand={updateCompanyBrand}
        />
      )}
    </SideModal>
  );
};

export default ManageBrandModal;
